/*
 * Module for the Employer Reporting Batches And Vouchers report criteria page
 */
rs.module("content/reports/criteria/employerreportingbatchesandvoucherscriteria",

    ["common/select-helper"],

    function (selectHelper) {

        // Initialize the page
        function initialize(jsSelectors, backendUrl) {

            var criteria = $.js(jsSelectors.criteria);

            var employerSelect = criteria.js(jsSelectors.employerSelect);
            var fiscalYearSelect = criteria.js(jsSelectors.fiscalYearSelect);

            // Get Select Helper for fiscalYearSelect since we're updating its options and properties
            var fiscalYearSelectHelper = selectHelper.getHelper(fiscalYearSelect);

            employerSelect.change(employerChanged);

            // On employer selection change,
            // Retrieve and rebind distinct Voucher Fiscal Years
            function employerChanged() {

                // get selected employerKey
                var selectedEmployerKey = employerSelect.val();

                // populate fiscal years based on selected employer
                fiscalYearSelectHelper.loadOptionsFrom(backendUrl, { employerKey: selectedEmployerKey });
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);